export const DEFAULT_DONATION_AMOUNT = 100_000;
export const MIN_DONATION_AMOUNT = 100;
